export default __webpack_public_path__ + "static/media/SCGC_Logo_White.df045539.png";